<template>
    <div class="component-notification pm-notification">
        <div class="notification"
             :class="{ success: (notification.style == 'success'), alert: (notification.style == 'alert'), warning: (notification.style == 'warning') }">
            <button class="close-button" aria-label="Close alert" type="button" @click="removeNotification()">
                <span aria-hidden="true">&times;</span>
            </button>
            <h4><strong>{{ notification.title }}</strong></h4>
            <span class="subtitle">{{ notification.subtitle }}</span>
        </div>
    </div>
</template>
<script type="text/babel">
    export default{
        name: "Notification",
        methods: {
            removeNotification: function () {
                this.$store.dispatch('removeNotification', this.notification)
            }
        },
        created() {
            setTimeout(() => {
                this.removeNotification()
            }, 5000);
        },
        props: ['notification']
    }
</script>
<style lang="sass" rel="stylesheet/sass">
</style>


// WEBPACK FOOTER //
// Notification.vue?1605a27e